"use client";

import React from "react";
import { MapPin, Clock, TrainFront, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from "@/components/ui/table";
const transportOptions = [{
  line: "TTC Line 1",
  stop: "Sheppard-Yonge Station",
  distance: "2 min walk"
}, {
  line: "TTC Line 4",
  stop: "Sheppard-Yonge Station",
  distance: "2 min walk"
}, {
  line: "GO Transit",
  stop: "Yonge & Sheppard",
  distance: "4 min walk"
}];
export default function OurLocation() {
  return <section data-section-id="233382" id="visit-our-clinic" className="bg-background text-foreground py-24 sm:py-32 overflow-hidden">
      {}
      <div className="container mx-auto px-6 md:px-12 mb-12 md:mb-20">
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-default font-light tracking-tight text-foreground">
          Visit Our North York Wellness Clinic – Easy Access via TTC & GO Transit
        </h2>
      </div>

      {}
      <div className="w-full h-[50vh] min-h-[400px] max-h-[600px] relative bg-muted">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653134/img/yonge_sheppard_clinic_exterior.png" alt="Top-Rated RMT and Facial Wellness Clinic Entrance in North York near Yonge and Sheppard" className="w-full h-full object-cover grayscale contrast-100 brightness-105" loading="lazy" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653134/img/yonge_sheppard_clinic_exterior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653134/img/yonge_sheppard_clinic_exterior.png-wvc-sizes" />
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2880.973844353345!2d-79.4144444234144!3d43.76301667109719!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b2d3f4e5a6b7d%3A0x123456789abcdef!2s1%20Elmhurst%20Ave%2C%20North%20York%2C%20ON%20M2N%201R3!5e0!3m2!1sen!2sca!4v1710000000000!5m2!1sen!2sca" className="absolute inset-0 w-full h-full border-0 transition-opacity duration-500" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Maps Location"></iframe>
        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center pointer-events-none">
          <div className="bg-primary text-primary-foreground p-3 rounded-lg shadow-2xl mb-2">
            <MapPin className="w-8 h-8" strokeWidth={1.5} />
          </div>
          <div className="bg-background/90 backdrop-blur-md px-4 py-1.5 rounded-md border border-border shadow-sm">
            <span className="font-default font-medium text-sm tracking-wide uppercase">1 Elmhurst Ave, North York, ON M2N 1R3</span>
          </div>
        </div>
      </div>

      {}
      <div className="container mx-auto px-6 md:px-12 mt-8 mb-20 md:mb-32 flex flex-col items-center text-center">
        <p className="text-xl md:text-2xl text-foreground font-default font-medium mb-2">1 Elmhurst Ave, North York, ON M2N 1R3</p>
        <p className="text-muted-foreground font-default mb-8 max-w-2xl">Conveniently located at 1 Elmhurst Ave, North York, ON M2N 1R3 Just steps away from the Sheppard-Yonge subway station.</p>
        <Link to="tel:416-938-9900">
          <Button variant="default" size="lg" className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300 px-12 h-16 font-default tracking-widest uppercase text-lg shadow-xl scale-105 hover:scale-110">
            <Phone className="w-6 h-6 mr-3" />
            Call Now: 416-938-9900
          </Button>
        </Link>
      </div>

      {}
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8">
          
          {}
          <div className="lg:col-span-5 space-y-16">
            {}
            <div>
              <h3 className="text-xl font-default font-medium mb-6 flex items-center gap-3 text-foreground">
                <MapPin className="w-5 h-5 text-primary" strokeWidth={1.5} />
                Our Address
              </h3>
              <p className="text-lg text-muted-foreground font-default leading-relaxed">1 Elmhurst Ave, North York, ON M2N 1R3</p>
            </div>

            {}
            <div>
              <h3 className="text-xl font-default font-medium mb-6 flex items-center gap-3 text-foreground">
                <Clock className="w-5 h-5 text-primary" strokeWidth={1.5} />
                Clinic Hours
              </h3>
              <p className="text-lg text-muted-foreground font-default leading-relaxed whitespace-pre-line">Mon-Sun 10AM- 9PM&nbsp;</p>
            </div>

            {}
            <div className="pt-8 border-t border-border">
              <div className="space-y-4">
                <Link to="tel:+14169389900" className="group flex items-center gap-4 text-lg font-default text-muted-foreground hover:text-primary transition-colors w-fit">
                  <Phone className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors" strokeWidth={1.5} />
                  416-938-9900
                </Link>
                <Link to="mailto:hello@yswellness.ca" className="group flex items-center gap-4 text-lg font-default text-muted-foreground hover:text-primary transition-colors w-fit">
                  <Mail className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors" strokeWidth={1.5} />
                  hello@yswellness.ca
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-6 lg:col-start-7">
            <h3 className="text-xl font-default font-medium mb-8 flex items-center gap-3 text-foreground">
              <TrainFront className="w-5 h-5 text-primary" strokeWidth={1.5} />
              Getting Here
            </h3>
            
            <div className="bg-card rounded-lg border border-border p-1 shadow-sm">
              <Table>
                <TableHeader>
                  <TableRow className="border-border hover:bg-transparent">
                    <TableHead className="font-default text-foreground font-medium py-4">Transit</TableHead>
                    <TableHead className="font-default text-foreground font-medium py-4">Stop</TableHead>
                    <TableHead className="font-default text-foreground font-medium text-right py-4">Distance</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {transportOptions.map((option, i) => <TableRow key={i} data-index={i} className="border-border hover:bg-accent/50 transition-colors">
                      <TableCell className="font-default text-muted-foreground py-4">{option.line}</TableCell>
                      <TableCell className="font-default text-foreground font-medium py-4">{option.stop}</TableCell>
                      <TableCell className="font-default text-muted-foreground text-right py-4">{option.distance}</TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>
            </div>

            <div className="mt-12 flex flex-col sm:flex-row gap-4">
              <Link to="https://yswellness.noterro.com" newTab className="w-full sm:w-auto">
                <Button variant="outline" size="lg" className="w-full rounded-lg border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 px-8 h-12 font-default tracking-wide uppercase text-sm shadow-md">
                  Book Your Visit
                </Button>
              </Link>
              <Link to="tel:416-938-9900" className="w-full sm:w-auto">
                <Button variant="default" size="lg" className="w-full rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300 px-8 h-12 font-default tracking-wide uppercase text-sm shadow-md">
                  Call Now
                </Button>
              </Link>
            </div>
          </div>

        </div>
      </div>
    </section>;
}